import { LitElement, html, nothing } from 'lit';
import { customElement } from 'lit/decorators.js';
import { AtlFormValidationProps } from './form.props';
import { getGlobalStyleSheets } from '../../global-styles';
import classNames from 'classnames';
import { enumAttributeConverter, Sizes, SizesValuesMap } from '../enum-types';

import * as TagNames from './form.tagnames';

@customElement(TagNames.FormValidation)
export class AtlFormValidation
   extends LitElement
   implements AtlFormValidationProps
{
   declare validationMessage?: string;
   declare validationCss?: string;
   declare size?: Sizes;

   static properties = {
      validationMessage: { type: String },
      validationCss: { type: String },
      size: {
         type: String,
         convertor: enumAttributeConverter(Sizes, Sizes.Medium),
      },
   };

   static styles = [...getGlobalStyleSheets()];

   render() {
      if (!this.validationMessage) return nothing;

      return html`
         <div
            class=${classNames(
               this.validationCss ||
                  'validation-feedback text-danger input-group',
               SizesValuesMap[this.size ?? Sizes.Small]
            )}
         >
            ${this.validationMessage}
         </div>
      `;
   }
}
